import { SignUpViewChanger } from '../util/view-changer/index.js'
import { PageView } from './PageView.js'
import { ProjectInvitationLayout } from '../components/layout/ProjectInvitationLayout.js'
import { Header } from '../components/Header.js'
import { IconButton } from '../components/button/IconButton.js'
import { InviterList } from '../components/InviterList.js'
import { addJoinUseInttId, getUser, setAsGuestUser } from '../store.js'
import { getCompanyInfoByInviteKey } from '../../../apiCall/signup/index.js'
import { getRegionPlanId } from "../util/plan/index.js";

export class ProjectInvitationView extends PageView {
    renderLayout() {
        const { mainText = '', subText = '' } = this.$props
        this.$props.ProjectInvitationLayout = new ProjectInvitationLayout(this.$target, {
            isAppend: true,
            sectionId: this.getSectionId(),
            mainText,
            subText
        })
    }

    renderComponents() {
        if (!this.$props.ProjectInvitationLayout) {
            return
        }

        new Header(this.$props.ProjectInvitationLayout.getHeaderLayer(), {
            isShowLoginBtn: true,
            isShowPrevBtn: false,
        })

        new IconButton(this.$props.ProjectInvitationLayout.getInviteButtonWrap(), {
            isAppend : true,
            id: 'joinAsGuest',
            icon : 'person',
            buttonText : i18next.t(login.invite.joinProjectGuestTitle),
            desc: i18next.t(login.invite.joinProjectGuestSubtitle),
            clickFunc : () => {
                if(Often.isGlobal()) {
                    SignUpViewChanger.loadBusinessEmailView(getRegionPlanId("basic"));
                } else {
                    setAsGuestUser(true)
                    SignUpViewChanger.loadGuestEmailView()
                }
            },
        })

        new IconButton(this.$props.ProjectInvitationLayout.getInviteButtonWrap(), {
            isAppend : true,
            id: 'joinAsEmployee',
            icon : 'company',
            buttonText : i18next.t(login.invite.joinProjectEmployeeTitle),
            desc: i18next.t(login.invite.joinProjectEmployeeSubtitle),
            clickFunc : async () => {
                const inviteKey = window?.CONNECT_INVITE_KEY
                if (Mutil.empty(inviteKey)) {
                    return
                }

                const { USE_INTT_ID = '' } = await getCompanyInfoByInviteKey(inviteKey)
                if (USE_INTT_ID === '') {
                    Mutil.toast('error', i18next.t(invite.invalidInvitation))
                    return
                }

                if (!USE_INTT_ID.startsWith('BFLOW')) {
                    Mutil.toast('error', i18next.t(invite.syncInstitutionRestricted))
                    return
                }

                addJoinUseInttId(USE_INTT_ID)

                SignUpViewChanger.loadInvitationCompanyView();
            },
        })

        this.renderInvitationList().then()
    }

    async renderInvitationList() {
        const invitationList = await getUser().getInviterList()
        if (invitationList.length < 1) {
            return
        }

        this.$props.ProjectInvitationLayout.showInvitationListLayer()

        new InviterList(this.$props.ProjectInvitationLayout.getInvitationListLayer(), {
            isAppend : true,
            inviterList: invitationList,
            moveCompanyInfoPage: () => {
                SignUpViewChanger.loadCompanyInfoView(true);
            },
        })
    }

    getSectionId() {
        return `invitationSelectSection`
    }
}